import React, { createContext, useContext, useState } from 'react';

const ProjectContext = createContext(null);

export const useProject = () => useContext(ProjectContext);

export const ProjectProvider = ({ children }) => {
  const [projectData, setProjectData] = useState({});

  const setProjectInfo = data => {
    setProjectData(data);
  };

  return (
    <ProjectContext.Provider value={{ projectData, setProjectInfo }}>
      {children}
    </ProjectContext.Provider>
  );
};
